module.exports = __webpack_public_path__ + "img/bar-chart.5d0de0e7.svg";